import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faFacebookF,
  faGooglePlusG,
  faPinterestP,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faCheckCircle,
  faFastBackward,
  faFastForward,
  faQuestionCircle,
  faShoppingCart,
  faSpinner,
  faStepBackward,
  faStepForward,
  faTimes,
  faTrashAlt,
  faWindowClose,
} from "@fortawesome/pro-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faAngleUp, faAngleDown);
library.add(faArrowLeft, faArrowRight);
library.add(faCheckCircle);
library.add(faFacebookF, faFastBackward, faFastForward);
library.add(faGooglePlusG);
library.add(faPinterestP);
library.add(faQuestionCircle);
library.add(faShoppingCart, faSpinner, faStepBackward, faStepForward);
library.add(faTimes, faTrashAlt, faTwitter);
library.add(faWindowClose);

Vue.component("fa-icon", FontAwesomeIcon);
